export interface CroppedImageInfo {
  croppedImage: Blob | null;
  croppedImageUrl: string;
}

export interface Area {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface UploadPOST {
  extension: string;
}

export interface UploadPOSTUrls {
  uploadUrl: string;
  downloadUrl: string;
  filePath: string;
}

export interface ImageUploadState {
  file?: File;
  fileSrc: string;
  isUploading: boolean;
  isUploadFinished: boolean;
  uploadProgress: number;
  cropAreaPixels: Area;
  croppedImageInfo: CroppedImageInfo;
  uploadUrls: UploadPOSTUrls;
  imageDeleted: boolean;
  error: string;
}

export interface Action {
  type: ACTION_TYPE;
  payload: any;
}

export interface ValidationsObject {
  [key: string]: { message: string; invalid: boolean; key: string };
}

export enum ACTION_TYPE {
  FILE = 'FILE',
  FILE_SRC = 'FILE_SRC',
  IS_UPLOADING = 'IS_UPLOADING',
  UPLOAD_FINISHED = 'UPLOAD_FINISHED',
  UPLOAD_PROGRESS = 'UPLOAD_PROGRESS',
  CROP_AREA_PIXELS = 'CROP_AREA_PIXELS',
  CROPPED_IMAGE_INFO = 'CROPPED_IMAGE_INFO',
  UPLOAD_URLS = 'UPLOAD_URLS',
  IMAGE_DELETED = 'IMAGE_DELETED',
  ERROR = 'ERROR',
}
